import { AiOutlinePlus } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { Button } from '../../../../../components/button/button';
import { DropdownStyleView } from '../../../../../features/dropdown-style-view/dropdown-style-view';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { concatPath } from '../../../../../helpers/path';
import { useLang } from '../../../../../hooks/use-lang';
import { FormPath, ManagerPath, RootPath } from '../../../../../routes/manager/manager-enums';
import s from './forms-controls.module.css';

export const FormsControls = () => {
  const { t } = useLang();

  return (
    <div className={s.feature}>
      <DropdownStyleView />

      <HasAccess service="form" permissions={['write']}>
        <Link to={concatPath([RootPath.Manager, ManagerPath.Form, FormPath.Create])}>
          <Button fullWidth size="lg">
            <AiOutlinePlus />
            {t('Добавить форму')}
          </Button>
        </Link>
      </HasAccess>
    </div>
  );
};
